export default {
    excess: 'Eigen risico',
    security: 'Borg',
    fuel_policy: 'Brandstofbeleid',
    like_for_like: 'Gelijkwaardig voertuig',
    full_to_full: 'Vol-vol',
    mileage: 'Kilometrage: {mileage} kilometer per huur',
    unlimited_mileage: 'Onbeperkte kilometers',
    non_refundable: 'Niet restitueerbaar',
    free_cancellation_until: 'Gratis annuleren tot {date}',
    cancellation_with_terms: 'Annulering {0} volgens ',
    t_c_text: 'Algemene voorwaarden',
    two_free_extras: "Twee gratis extra's bij ophalen",
    glass_tyres_covered: 'Ruiten en banden gedekt',
    spec_fuel_petrol: 'benzine',
    spec_fuel_petrol_diesel: 'benzine/diesel',
};
